<mat-form-field subscriptSizing="dynamic" class="w-full">
  <mat-label>{{ label }}</mat-label>
  @if (formCtrl.value) {
    <button mat-icon-button matSuffix aria-label="Clear" (click)="clearInput()">
      <mat-icon>clear</mat-icon>
    </button>
  }
  <mat-select
    [formControl]="formCtrl"
    [required]="required"
    [compareWith]="compareWithFn"
  >
    <ng-container *ngIf="store.brandTreatments$ | async as brandTreatments">
      <mat-optgroup *ngIf="brandTreatments.length" label="Brand Treatments">
        <mat-option
          *ngFor="
            let configuration of brandTreatments;
            trackBy: trackByConfiguration
          "
          [value]="configuration"
        >
          {{ configuration.name }}
        </mat-option>
      </mat-optgroup>
    </ng-container>

    <ng-container *ngIf="store.stafferTreatments$ | async as stafferTreatments">
      <mat-optgroup *ngIf="stafferTreatments.length" label="Staffer Treatments">
        <mat-option
          *ngFor="
            let configuration of stafferTreatments;
            trackBy: trackByConfiguration
          "
          [value]="configuration"
        >
          {{ configuration.name }}
        </mat-option>
      </mat-optgroup>
    </ng-container>

    <ng-container
      *ngIf="store.brandMultiTreatments$ | async as brandMultiTreatments"
    >
      <mat-optgroup
        *ngIf="brandMultiTreatments.length"
        label="Brand Multi Treatments"
      >
        <mat-option
          *ngFor="
            let configuration of brandMultiTreatments;
            trackBy: trackByConfiguration
          "
          [value]="configuration"
        >
          {{ configuration.name }}
        </mat-option>
      </mat-optgroup>
    </ng-container>

    <ng-container
      *ngIf="store.stafferMultiTreatments$ | async as stafferMultiTreatments"
    >
      <mat-optgroup
        *ngIf="stafferMultiTreatments.length"
        label="Staffer Multi Treatments"
      >
        <mat-option
          *ngFor="
            let configuration of stafferMultiTreatments;
            trackBy: trackByConfiguration
          "
          [value]="configuration"
        >
          {{ configuration.name }}
        </mat-option>
      </mat-optgroup>
    </ng-container>
  </mat-select>
</mat-form-field>
